export const iconFontAwesomeCodingShieldHalved = (
	<i className="fa-solid fa-shield-halved"></i>
);
